import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

class ShiftCashService {
  getAvailableForCheckoutShifts() {
    return axios.get(API_URL + "shiftcash/shift", {
      headers: authHeader(),
    });
  }

  getAvailableForDepositShifts() {
    return axios.get(API_URL + "shiftcash/shift?isdeposited=false", {
      headers: authHeader(),
    });
  }

  postAvailableForCheckoutToDepositCashes(postCashes: any) {
    console.log(postCashes);
    return axios.post(API_URL + "shiftcash/shift", postCashes, {
      headers: authHeader(),
    });
  }

  postAvailableForDepositToBankCashes(depositEntityId: any) {
    return axios.post(API_URL + "shiftcash/deposittobank", depositEntityId, {
      headers: authHeader(),
    });
  }

  /**
   * Usage: Gets a pdf from back-end then opens pdf report in a new tab.
   */
  getDepositPrint(language: string) {
    const append = "shiftcash/getpdf?language=" + language;
    axios
      .get(API_URL + append, {
        headers: authHeader(),
        responseType: "blob",
      })
      .then(({ data }) => {
        console.log(data);

        const downloadUrl = window.URL.createObjectURL(
          new Blob([data], { type: "application/pdf" })
        );

        // Use window or link not both
        window.open(downloadUrl);

        ////Link starts here
        // const link = document.createElement("a");
        // link.href = downloadUrl;

        // //// To download the file use below line
        // link.setAttribute("download", "report.pdf"); //any other extension

        // link.target = "_blank";

        // link.click();
        // link.remove();
      });
  }
}

export default new ShiftCashService();
